import React, { useEffect, useState } from "react";
import SidebarBlog from "../components/blog/sidebar-blog";
import Layout from "../components/layout/layout";
import blogService from "../services/blogService";
import MyBlog from "../components/blog/my-blog";
import { useSelector } from "react-redux";
import SearchBlog from "../components/blog/search-blog";

const MyBlogPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [filteredBlogs, setFilteredBlogs] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { userInfo } = useSelector((state) => state.user);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        setLoading(true);
        const data = await blogService.getBlogsByUserId(userInfo.id);
        setBlogs(data);
        setFilteredBlogs(data); // Initially, show all blogs
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
    fetchBlogs();
  }, []);

  // Handle search query changes
  useEffect(() => {
    const filtered = blogs.filter((blog) =>
      `${blog.name}`.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredBlogs(filtered);
  }, [searchQuery, blogs]);

  return (
    <Layout>
      <div className="content">
        <div className="container">
          <div className="row">
            <SearchBlog setSearchQuery={setSearchQuery} />
            <MyBlog blogs={filteredBlogs} loading={loading} error={error} />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default MyBlogPage;
